import { Button, ButtonProps } from "antd";
import { useContext } from "react";
import { GLOB } from "src/util/Glob";
import { AllItemsContext } from "../comp/AllItems";
import { invalidHwProps, RuleContext } from "../XmRule";
import { RuleGroup } from "../XmRuleList";

const AddButton = ({ disabled, ...rest }: ButtonProps) => {
  const { cls, subsystem, hw_type } = useContext(AllItemsContext);
  const invalidBaseProps = invalidHwProps({ cls, hw_type, subsystem });
  const { getValue } = useContext(RuleContext);

  const exclude = getValue<RuleGroup['exclude']>('exclude');
  const { readonly } = GLOB.userInfo;
  const isDisabled = readonly || invalidBaseProps || disabled;

  return <div className={!!exclude ? 'xm-rule-controllers-footer' : 'xm-rule-controllers-footer disabled'}>
    <Button size='small' disabled={isDisabled} {...rest}>Add Item</Button>
  </div>;
};

export default AddButton;
